const AdminTableCard = ({ children }) => (
  <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white shadow-sm">
    {children}
  </div>
);

export default AdminTableCard;
